import { useGT } from 'gt-react';
import { Button } from 'src/components/ui/button';
import type { Span } from './types';

/** One selected action persists when changing between the rail and full trace. */
export function ActionNavigation({
  actions,
  selected,
  onSelect,
}: {
  actions: Span[];
  selected: Span | null;
  onSelect: (id: string) => void;
}) {
  const gt = useGT();
  if (!actions.length) return null;
  const index = actions.findIndex((span) => span.id === selected?.id);
  function move(offset: number) {
    const next = actions[index + offset];
    if (next) onSelect(next.id);
  }
  return (
    <div className="flex items-center justify-between gap-2 border-b px-3 py-2">
      <span className="text-xs text-muted-foreground">
        {index >= 0
          ? gt('Action {number} of {total}', {
              context: 'shared run action navigation',
              number: String(index + 1),
              total: String(actions.length),
            })
          : gt('{total} recorded actions', {
              context: 'shared run action count',
              total: String(actions.length),
            })}
      </span>
      <div className="flex gap-1">
        <Button
          variant="outline"
          size="sm"
          disabled={index <= 0}
          onClick={() => move(-1)}
        >
          {gt('Previous', { context: 'previous recorded action' })}
        </Button>
        <Button
          variant="outline"
          size="sm"
          disabled={index >= actions.length - 1}
          onClick={() => move(1)}
        >
          {gt('Next', { context: 'next recorded action' })}
        </Button>
      </div>
    </div>
  );
}
